"use client";

import { createContext, useContext, type PropsWithChildren } from "react";

interface StoryblokContext {
  onPublished?: () => void;
}

const StoryblokContext = createContext<StoryblokContext>(null!);

export const StoryblokProvider = ({
  children,
  onPublished,
}: PropsWithChildren<StoryblokContext>) => {
  return (
    <StoryblokContext.Provider value={{ onPublished }}>
      {children}
    </StoryblokContext.Provider>
  );
};

export const useStoryblokContext = () => {
  return useContext(StoryblokContext);
};
